module.exports = __webpack_public_path__ + "img/w5-b2.9a7de957.jpg";